/**
 * Shared low-stock alert threshold for Stock UI, POS badges, and dashboard KPIs.
 * Prefer product.alertThreshold, then minStock, then default. Uses nullish coalescing
 * so an explicit 0 is respected (unlike `||` fallbacks).
 */

export const DEFAULT_LOW_STOCK_THRESHOLD = 5;

/**
 * @param {object|null|undefined} product
 * @returns {number}
 */
export function resolveLowStockThreshold(product) {
  if (!product) return DEFAULT_LOW_STOCK_THRESHOLD;
  const raw = product.alertThreshold ?? product.minStock;
  if (raw === null || raw === undefined || raw === '') {
    return DEFAULT_LOW_STOCK_THRESHOLD;
  }
  const n = Number(raw);
  if (!Number.isFinite(n)) return DEFAULT_LOW_STOCK_THRESHOLD;
  return Math.max(0, n);
}

/**
 * True when stock is still sellable but at/below the product alert threshold.
 * Out-of-stock (≤0) is not treated as “low stock” — use a separate out-of-stock check.
 */
export function isLowStock(stockNow, product) {
  const stock = Number(stockNow) || 0;
  if (stock <= 0) return false;
  return stock <= resolveLowStockThreshold(product);
}
